export const MORE_DETAILS_LINK = 'more-details-link';
export const MORE_DETAILS_HREF = '/privacy';
export const COOKIE_DASHBOARD_LINK = 'cookie-dashboard-link';
export const COOKIE_DASHBOARD_HREF = '/cookie-dashboard';

// Message Properties
export const HTML_FORMATTED_MESSAGE_ID =
  'shared.components.CookieBanner.gdprInformation';
export const HTML_FORMATTED_MESSAGE = `
Mit Klick auf "Einverstanden" stimmst du zu, dass wir Deine Nutzung unserer
Plattform durch Cookies (von heycar und Dritten) nachverfolgen, um deine
Nutzungserfahrung und dir angezeigte Werbung zu analysieren und personalisieren
(<a href="${MORE_DETAILS_HREF}"><strong id="${MORE_DETAILS_LINK}">mehr Details</strong></a>).
Du stimmst damit auch zu, dass deine Daten hierbei ohne geeignete
Datenschutzgarantien an Partner in sog. Drittländern übermittelt
werden können, die kein angemessenes Datenschutzniveau bieten, wie z.B. die
USA aufgrund staatlicher Zugriffsmöglichkeiten. Alternativ kannst du deine
Cookie Einstellungen im <a href="${COOKIE_DASHBOARD_HREF}"><strong id="${COOKIE_DASHBOARD_LINK}">Cookie Dashboard</strong></a>
jetzt und jederzeit später individuell anpassen.
`;
